import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Link from 'gatsby-link'
import { withStyles } from 'material-ui/styles'
import Grid from 'material-ui/Grid'
import Typography from 'material-ui/Typography/Typography';
import List, {
  ListItem,
  ListItemIcon,
  ListItemText,
  ListSubheader
} from 'material-ui/List'

// import FontAwesomeIcon from '@fortawesome/react-fontawesome'

import * as SiteConfig from '../../config/Config'

import FooterLogo from '../FooterLogo'

const styles = theme => ({
  outsideBg: {
    backgroundColor: theme.palette.primary.main
  },
  columnBg: {
    backgroundColor: theme.palette.primary.main,
  },
  sectionTitle: {
    color: theme.palette.secondary.dark,
  },
  listItem: {
    // color: theme.palette.secondary.contrastText,
    // color: theme.palette.common.white,
    // color: theme.palette.text.primary,
    // color: theme.palette.grey[50],
    // color: theme.palette.secondary.main,
    textAlign: 'center',
  },
  link: {
    // color: theme.palette.secondary.main,
    textDecoration: 'none',
  },
})

class Footer extends Component {
  render() {

    const { classes } = this.props

    return (
    <Grid
      /* full width background */
      container
      spacing={0}
      justify="center"
      className={classes.outsideBg}
    >
      <Grid
        /* page center column */
        item
        xs={11}
        md={10}
        className={classes.columnBg}
      >

        <Grid container spacing={0}>

          {/* Logo section */}
          <Grid
            item
            xs={12}
          >
            <FooterLogo
              image={SiteConfig.footerLogo.image}
              altText={SiteConfig.footerLogo.altText}
              width={`${SiteConfig.footerLogo.width}px`}
              height={`${SiteConfig.footerLogo.height}px`}
            />
          </Grid>

          {/* Column 1 */}
          {/* <Grid
            item
            xs={12}
            md
            // hidden={{ xsUp: true }}
          >
            
            <List
              subheader={
                <Typography
                  variant="title"
                  component="h3"
                  align="center"
                  className={classes.sectionTitle}
                >
                  Contact Info
                </Typography>
              }
            >

              <ListItem className={classes.listItem}>
                <ListItemText primary={SiteConfig.business.name} />
              </ListItem>

              <ListItem className={classes.listItem}>
                <ListItemText primary={SiteConfig.business.address.street} />
              </ListItem>

              <ListItem className={classes.listItem}>
                <ListItemText primary={`${SiteConfig.business.address.city}, ${SiteConfig.business.address.state} ${SiteConfig.business.address.zipcode}`} />
              </ListItem>

              <ListItem button className={classes.listItem}>
                <ListItemIcon><FontAwesomeIcon icon={} /></ListItemIcon>
                <ListItemText primary={SiteConfig.business.email} />
              </ListItem>

              <ListItem button className={classes.listItem}>
                <ListItemIcon><FontAwesomeIcon /></ListItemIcon>
                <ListItemText primary={SiteConfig.business.phoneNumber} />
              </ListItem>

            </List>
          </Grid> */}

          {/* Column 2 */}
          <Grid
            item
            xs={12}
            md
          >

              <List
                component="nav"
                subheader={
                  <Typography
                    variant="title"
                    component="h3"
                    align="center"
                    className={classes.sectionTitle}
                  >
                    Browse
                  </Typography>
                }
              >

                <Link to="/" className={classes.link}>
                  <ListItem button className={classes.listItem}>
                    <ListItemText primary="Home" />
                  </ListItem>
                </Link>

                <Link to="/about" className={classes.link}>
                  <ListItem button className={classes.listItem}>
                    <ListItemText primary="About" />
                  </ListItem>
                </Link>

                <Link to="/contact" className={classes.link}>
                  <ListItem button className={classes.listItem}>
                    <ListItemText primary="Contact" />
                  </ListItem>
                </Link>

                <Link to="/sitemap.xml" className={classes.link}>
                  <ListItem button className={classes.listItem}>
                    <ListItemText primary="Sitemap" />
                  </ListItem>
                </Link>

              </List>

          </Grid>

        </Grid>
        
      </Grid> {/* END: columnBg */}
      
    </Grid> /* END: outsideBg */
    );
  }
}

Footer.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Footer)


// WEBPACK FOOTER //
// ./src/components/Footer/index.js